import React from "react";
import Table from "../../widgets/tableCrm/Table";
import SelectInput from "../../widgets/SelectInput";

const TableSection = ({
  tables,
  titleFilter,
  searchCols,
  onCellClick,
  headCell,
}) => {
  const generateRows = (data) => {
    return Object.keys(data).map((key) => ({
      id: key,
      prov: key,
      TR: data[key]?.TR?.count || 0,
      R: data[key]?.R?.count || 0,
      OP: data[key]?.OP?.count || 0,
      DOPP: data[key]?.DOPP?.count || 0,
      TS: data[key]?.TS?.count || 0,
      HS: data[key]?.HS?.count || 0,
      AD: data[key]?.AD?.count || 0,
      BARBE: data[key]?.BARBE?.count || 0,
      MONOLOGO: data[key]?.MONOLOGO?.count || 0,
      SFX: data[key]?.SFX?.count || 0,
      TEMP: data[key]?.TEMPTU?.count || 0,
    }));
  };

  // Funzione per calcolare il totale di tutti i valori nella tabella
  const calculateTotal = (data) => {
    if (!data) return 0;

    let total = 0;
    Object.keys(data).forEach((key) => {
      const row = data[key];
      if (row) {
        total += row.TR?.count || 0;
        total += row.R?.count || 0;
        total += row.OP?.count || 0;
        total += row.DOPP?.count || 0;
        total += row.TS?.count || 0;
        total += row.HS?.count || 0;
        total += row.AD?.count || 0;
        total += row.BARBE?.count || 0;
        total += row.MONOLOGO?.count || 0;
        total += row.SFX?.count || 0;
        total += row.TEMPTU?.count || 0;
      }
    });

    return total;
  };

  return (
    <div style={{ flex: "1 ", marginBottom: "20px" }}>
      {tables
        .filter((table) => table.name.includes(titleFilter))
        .map((table, idx) => {
          const rows = table.data
            ? generateRows(table.data)
            : [{ id: "No Data", prov: 0 }];

          const total = calculateTotal(table.data);

          return (
            <div key={`${table.name}-${idx}`}>
              <div
                style={{
                  marginBottom: "10px",
                  fontWeight: "bold",
                  fontSize: "1.1em",
                  maxHeight: "30px",
                }}
              >
                {table.name}: TOTALE {total}
              </div>
              <Table
                headCells={headCell}
                searchCols={searchCols}
                rows={rows}
                noCerca
                leadsClick
                assenze={false}
                calendar={false}
                tableVersion={false}
                pdf={false}
                excel={false}
                mail={false}
                phone={false}
                onCellClick={(row, col) => {
                  onCellClick(row, col, table);
                }}
              />
            </div>
          );
        })}
    </div>
  );
};

export default TableSection;
